import React, { useEffect, useRef } from 'react';
import './ReportBox.css'
import Modelos from '../../../components/Modelos';
import Message from '../../../components/Message';
import CircularProgress from '@mui/material/CircularProgress'; // Importa o ícone de loading
import { useTranslation } from 'react-i18next';

function ReportBox({chatHistory, classeCSS, loading, model, setModel, messages, setMessages, assistant, assistantId, totalCost}){
    const messagesEndRef = useRef(null);
    const { t: tChat } = useTranslation('chat');

    useEffect(() => {
        if (chatHistory.length > 0) {
            setMessages(chatHistory);  // Atualiza o estado interno com o histórico recebido
        }
    }, [chatHistory, setMessages]);

    // Função para rolar até o final da lista de mensagens
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        };

        // useEffect para rolar até o final sempre que as mensagens mudarem
        useEffect(() => {
            scrollToBottom();
        }, [messages]);

    const normalizedCost = Number.isFinite(Number(totalCost)) ? Number(totalCost) : 0;

    return(
        <main className={classeCSS}>

            <header className='reportbox-superior'>
                <Modelos setModel={setModel} defaultModel={model} isReportBox={true}/>
                <div className='custo-sessao'>
                    <img src="/imagens/cifrao.svg" alt="" className="menu-item-icon" />
                    <p className="custo-texto"> <strong>{tChat('session_cost')}</strong> <span>U${normalizedCost.toFixed(2)}</span></p>
                </div>
            </header>

            <section className='reports-container'>
                {loading ? (
                    <div className="loading-container-historico">
                        <CircularProgress /> {/* Ícone de loading */}
                    </div>
                ) : (
                    messages.map((msg, index) => (
                        <Message
                            key={index}
                            msg={msg}
                            index={index}
                            isReportBox={true}
                            assistant={assistant}
                        />
                    ))
                )}

                <div style={{display: 'none'}} ref={messagesEndRef} />
            </section>
        
        </main>
    )
}

export default ReportBox;